  import React, { useState, useEffect } from "react";
  import { Table, Checkbox, Button, Collapse, Tabs, message ,Input, Spin} from "antd";
  import { ArrowLeftOutlined } from "@ant-design/icons";
  import ApiService from "../Components/apiService";
  import { BASE_URL } from "../Components/Constant";
import { configConsumerProps } from "antd/es/config-provider";

  const AccessPolicyReadWriteForFields = ({ selectedObjects, onBack, objectSettingsData,accessPolicyData,selectedAccessPolicy,onMain }) => {
    const [selectedPermissions, setSelectedPermissions] = useState({});
    const [activeTab, setActiveTab] = useState("object");
    const [objectSearchTerm, setObjectSearchTerm] = useState("");
    const [fieldSearchTerm, setFieldSearchTerm] = useState("");
    const [loading,setLoading] = useState(false);


 
    const handleCheckboxChange = (key, type, checked) => {
      setSelectedPermissions((prev) => {
        const updatedPermissions = { ...prev };
        
        // Update the permission for the current checkbox
        updatedPermissions[key] = {
          ...updatedPermissions[key],
          [type]: checked,
        };
    
        // If "Create" is selected, automatically select "View" and "Edit"
        if (type === "create" && checked) {
          updatedPermissions[key] = {
            ...updatedPermissions[key],
            view: true,
            edit: true,
          };
        }
    
        // If "Edit" is selected, automatically select "View"
        if (type === "edit" && checked) {
          updatedPermissions[key] = {
            ...updatedPermissions[key],
            view: true,
          };
        }
    
        // If "Delete" is selected, automatically select "View"
        if (type === "delete" && checked) {
          updatedPermissions[key] = {
            ...updatedPermissions[key],
            view: true,
          };
        }
    
        return updatedPermissions;
      });
    };
    
    const handleSelectAll = (type, checked) => {
      setSelectedPermissions((prev) => {
        const updatedPermissions = { ...prev };
    
        // Check if the active tab is "object" or "field" to apply changes accordingly
        if (activeTab === "object") {
          // If selecting all objects
          selectedObjects.forEach((objectName) => {
            updatedPermissions[objectName] = {
              ...updatedPermissions[objectName],
              [type]: checked,
            };
    
            // Apply automatic selections based on type for object-level permissions
            if (type === "create" && checked) {
              updatedPermissions[objectName] = {
                ...updatedPermissions[objectName],
                view: true,
                edit: true,
              };
            }
    
            if (type === "edit" && checked) {
              updatedPermissions[objectName] = {
                ...updatedPermissions[objectName],
                view: true,
              };
            }
    
            if (type === "delete" && checked) {
              updatedPermissions[objectName] = {
                ...updatedPermissions[objectName],
                view: true,
              };
            }
          });
        } else if (activeTab === "field") {
          // If selecting all fields
          selectedObjects.forEach((objectName) => {
            const fields = objectSettingsData[objectName]?.field_setting || {};
            Object.entries(fields).forEach(([fieldName, fieldPermissions]) => {
              updatedPermissions[`${objectName}-${fieldName}`] = {
                ...updatedPermissions[`${objectName}-${fieldName}`],
                [type]: checked,
              };
    
              // Apply automatic selections based on type for field-level permissions
              if (type === "create" && checked) {
                updatedPermissions[`${objectName}-${fieldName}`] = {
                  ...updatedPermissions[`${objectName}-${fieldName}`],
                  view: true,
                  edit: true,
                };
              }
    
              if (type === "edit" && checked) {
                updatedPermissions[`${objectName}-${fieldName}`] = {
                  ...updatedPermissions[`${objectName}-${fieldName}`],
                  view: true,
                };
              }
    
              if (type === "delete" && checked) {
                updatedPermissions[`${objectName}-${fieldName}`] = {
                  ...updatedPermissions[`${objectName}-${fieldName}`],
                  view: true,
                };
              }
            });
          });
        }
    
        return updatedPermissions;
      });
    };
    const formatPermissions = (data) => {
      const permissions = {};
  
      selectedObjects.forEach((objectName) => {
        const objectSettings = data[objectName]?.object_setting || {};
        const fields = data[objectName]?.field_setting || {};
  
        permissions[objectName] = {
          create: objectSettings.create || false,
          view: objectSettings.view || false,
          edit: objectSettings.edit || false,
          delete: objectSettings.delete || false,
        };
  
        Object.entries(fields).forEach(([fieldName, fieldPermissions]) => {
          permissions[`${objectName}-${fieldName}`] = {
            create: fieldPermissions.create || false,
            view: fieldPermissions.view || false,
            edit: fieldPermissions.edit || false,
            delete: fieldPermissions.delete || false,
          };
        });
      });
  
      return permissions;
    };
  

    useEffect(() => {
      const fetchFields = async () => {
        try {
          setLoading(true);
          const response = await Promise.all(
            selectedObjects.map(async (objectName) => {
              const apiService = new ApiService(`${BASE_URL}/mt_fields/object/${objectName}`, {
                "Content-Type": "application/json",
              });
              return { objectName, fields: await apiService.makeCall() };
            })
          );
    
          const updatedObjectSettings = { ...objectSettingsData };
    
          response.forEach(({ objectName, fields }) => {
            if (!updatedObjectSettings[objectName]) {
              updatedObjectSettings[objectName] = { object_setting: {}, field_setting: {} };
            }
    
            // Ensure object permissions exist and default to false if not present
            updatedObjectSettings[objectName].object_setting = {
              create: updatedObjectSettings[objectName].object_setting.create || false,
              view: updatedObjectSettings[objectName].object_setting.view || false,
              edit: updatedObjectSettings[objectName].object_setting.edit || false,
              delete: updatedObjectSettings[objectName].object_setting.delete || false,
            };
    
            // Ensure all fields exist in field_setting with default permissions as false
            fields.forEach((field) => {
              if (!updatedObjectSettings[objectName].field_setting[field.name]) {
                updatedObjectSettings[objectName].field_setting[field.name] = {
                  create: false,
                  view: false,
                  edit: false,
                  delete: false,
                };
              }
            });
          });
    
          setSelectedPermissions(formatPermissions(updatedObjectSettings));
        } catch (error) {
          console.error("Error fetching fields:", error);
        }
        finally{
          setLoading(false);
        }
      };
    
      fetchFields();
    }, [selectedObjects]);
    
    
    const handleSave = async () => {
      setLoading(true);
      const updatedObjectSettings = { ...objectSettingsData }; // Start with existing data
    
      selectedObjects.forEach((objectName) => {
        // Update only the objects that are in `selectedObjects`
        updatedObjectSettings[objectName] = {
          object_setting: {
            create: selectedPermissions[objectName]?.create || false,
            view: selectedPermissions[objectName]?.view || false,
            edit: selectedPermissions[objectName]?.edit || false,
            delete: selectedPermissions[objectName]?.delete || false,
          },
          field_setting: { ...updatedObjectSettings[objectName]?.field_setting }, // Preserve existing field settings
        };
    
        // Handle field-level permissions
        Object.keys(selectedPermissions).forEach((key) => {
          if (key.startsWith(`${objectName}-`)) {
            const fieldName = key.split(`${objectName}-`)[1];
            updatedObjectSettings[objectName].field_setting[fieldName] = {
              create: selectedPermissions[key]?.create || false,
              view: selectedPermissions[key]?.view || false,
              edit: selectedPermissions[key]?.edit || false,
              delete: selectedPermissions[key]?.delete || false,
            };
          }
        });
      });
    
     
      try {
        accessPolicyData.object_settings = updatedObjectSettings;
    
        const apiService = new ApiService(
          `${BASE_URL}/update_access_policy/${selectedAccessPolicy}`,
          { 'Content-Type': 'application/json' },
          'PATCH',
          accessPolicyData
        );
    
         const response = await apiService.makeCall();
         message.success('Object Settings Updated successfully');
         onMain();
      } catch (error) {
        console.error("Error updating permissions:", error);
      }
      finally
      {
        setLoading(false);
      }
    };
    
    const handleCancel = () => {
      // Reset the selectedPermissions state to its initial state
      const initialPermissions = {};
    
      selectedObjects.forEach((objectName) => {
        const objectSettings = objectSettingsData[objectName]?.object_setting || {};
        const fields = objectSettingsData[objectName]?.field_setting || {};
    
        // Store object-level permissions
        initialPermissions[objectName] = {
          create: objectSettings.create || false,
          view: objectSettings.view || false,
          edit: objectSettings.edit || false,
          delete: objectSettings.delete || false,
        };
    
        // Store field-level permissions
        Object.entries(fields).forEach(([fieldName, fieldPermissions]) => {
          initialPermissions[`${objectName}-${fieldName}`] = {
            create: fieldPermissions.create || false,
            view: fieldPermissions.view || false,
            edit: fieldPermissions.edit || false,
            delete: fieldPermissions.delete || false,
          };
        });
      });
    
      // Update the selectedPermissions state to its initial state
      setSelectedPermissions(initialPermissions);

      message.success('Changes reverted successfully');
    };
    
    // Group data for selected objects and their fields
    const groupedData = selectedObjects.map((objectName) => {
      const objectSettings = objectSettingsData[objectName]?.object_setting || {};
      const fields = objectSettingsData[objectName]?.field_setting || {};

      const objectRow = {
        key: objectName,
        name: objectName,
        isObject: true,
        isField:false,
        objectName: objectName,  
        ...objectSettings,
      };

      const fieldData = {
        key: objectName,
        name: objectName, 
        isObject: false,
        isField:true,
        children: Object.entries(fields).map(([fieldName, fieldPermissions]) => ({
          key: `${objectName}-${fieldName}`, // Unique key for each field
          name: fieldName, // Field name
          isObject: true,
          objectName: objectName,
          ...fieldPermissions,
        })),
      }
    

      return [objectRow, fieldData];
    }).flat(); 

    const filteredObjectData = groupedData
    .filter((item) => !item.isField && item.name.toLowerCase().includes(objectSearchTerm.toLowerCase()));

    const filteredFieldData = groupedData
      .filter(item => item.isField) // Ensure only field-level items are considered
      .map(item => ({
        ...item,
        children: item.children.filter(child => 
          child.name.toLowerCase().includes(fieldSearchTerm.toLowerCase())
        ) // Filter children fields
      }))
      .filter(item => item.children.length > 0); 


    const columns = [
      {
        title: activeTab === "object" ? "Object" : "Field",
        dataIndex: "name",
        key: "name",
        sticky: true, 
      },
      {
        title: (
                <div>
                  <Checkbox
                    style={{ marginRight: "5px" }}
                    onChange={(e) => handleSelectAll("create", e.target.checked)}
                  />
                  Create
                </div>
        ),
        dataIndex: "create",
        key: "create",
        render: (_, record) =>
          !record.isField ? (
            <Checkbox
              checked={selectedPermissions[record.key]?.create || false}
              onChange={(e) => handleCheckboxChange(record.key, "create", e.target.checked)}
            />
          ) : null,
        
      },
      {
        title:  (
          <div>
            <Checkbox
              style={{ marginRight: "5px" }}
              onChange={(e) => handleSelectAll("view", e.target.checked)}
            />
            View
          </div>
        ),
        dataIndex: "view", 
        key: "view",
        render: (_, record) => 
          !record.isField ? (
          <Checkbox
            checked={selectedPermissions[record.key]?.view || false}
            onChange={(e) => handleCheckboxChange(record.key, "view", e.target.checked)}
            disabled={record.isField} // Disable checkboxes for object-level rows
          />
        ) : null,

      },
      {
        title:  (
          <div>
            <Checkbox
              style={{ marginRight: "5px" }}
              onChange={(e) => handleSelectAll("edit", e.target.checked)}

            />
            Edit
          </div>
        ),
        dataIndex: "edit",
        key: "edit",
        render: (_, record) => 
          !record.isField ? (
          <Checkbox
            checked={selectedPermissions[record.key]?.edit || false}
            onChange={(e) => handleCheckboxChange(record.key, "edit", e.target.checked)}
            disabled={record.isField} // Disable checkboxes for object-level rows
          />
        ) : null,
      
      },
      {
        title:  (
          <div>
            <Checkbox
              style={{ marginRight: "5px" }}
              onChange={(e) => handleSelectAll("delete", e.target.checked)}

            />
            Delete
          </div>
        ),
        dataIndex: "delete",
        key: "delete",
        render: (_, record) => 
          !record.isField ? (
          <Checkbox
            checked={selectedPermissions[record.key]?.delete || false}
            onChange={(e) => handleCheckboxChange(record.key, "delete", e.target.checked)}
            disabled={record.isField} // Disable checkboxes for object-level rows
          />
        ) : null,
      },
    ];



    return (
      <Spin spinning={loading}>
      <div style={{ padding: "16px", height: "60vh" }}>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "16px" }}>
          <Button icon={<ArrowLeftOutlined />} type="link" onClick={onBack}>
            Go Back
          </Button>
          <div>
            <Button type="default" style={{ marginRight: "8px" }} onClick={handleCancel}>
              Cancel
            </Button>
            <Button type="primary" onClick={handleSave}>
              Save
            </Button>
          </div>
        </div>
        <Tabs activeKey={activeTab} onChange={setActiveTab}>
          <Tabs.TabPane tab="Object Permissions" key="object" style={{ height: "70vh", overflowY: "auto" }}>
          <Input
            placeholder="Search Objects"
            value={objectSearchTerm}
            onChange={(e) => setObjectSearchTerm(e.target.value)}
            style={{ marginBottom: "16px" }}
          />
            <Table
              dataSource={filteredObjectData}
              columns={columns}
              pagination={false}
              sticky
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Field Permissions" key="field" style={{ height: "70vh", overflowY: "scroll" }}>
          <Input
            placeholder="Search Fields"
            value={fieldSearchTerm}
            onChange={(e) => setFieldSearchTerm(e.target.value)}
            style={{ marginBottom: "16px" }}
          />
            <Table
              dataSource={filteredFieldData}
              columns={columns}
              rowClassName={(record) => (record.isObject ? "object-row" : "field-row")}
              pagination={false}
              expandable={{
                expandedRowRender: (record) => 
                  // Render additional details for fields
                  record.isObject ? null : '',
                rowExpandable: (record) => !record.isObject,
              }}  
              defaultExpandedRowKeys={filteredFieldData.length > 0 ? [filteredFieldData[0].key] : []} 
              sticky
            />
          </Tabs.TabPane>
        </Tabs>
      </div>
      </Spin>
    );
  };

  export default AccessPolicyReadWriteForFields;
